// @ts-check
import {apiClient} from 'common/util/api-client';

// custom-alert api consumers expect {error, status} result rather than an error to be thrown  ¯\_(ツ)_/¯
/* eslint-disable local-rules/deprecated-member-access */

const processResponse = (response) => {
  if (response.ok || response.status === 200) {
    return response.json().then((results) => results.results);
  } else {
    return response.json().then((results) => {
      console.error(response.status, results.error);
      return {
        error: results.error,
        status: response.status,
      };
    });
  }
};

const encodeBody = (body) => {
  return body && JSON.stringify(body);
};

const fetch = (method, url, body) => {
  if (method === `GET`) {
    return apiClient.fetch(url, {method});
  } else {
    return apiClient.fetch(url, {method, body: encodeBody(body)});
  }
};

export class ProjectApi {
  constructor(projectId) {
    this.baseUrl = `/api/app/projects/${projectId}`;
  }

  getGrantedUsersForProject() {
    const url = `${this.baseUrl}/granted-users`;
    return fetch(`GET`, url).then((response) => processResponse(response));
  }
}

export class UserApi {
  getSelf() {
    return fetch(`GET`, `/api/app/me`).then((response) => processResponse(response));
  }
}

export class CustomAlertApi {
  constructor(projectId) {
    this.baseUrl = `/api/app/projects/${projectId}/alerts/custom/`;
  }

  loadCustomAlertsForBookmark(bookmarkId) {
    return fetch(`GET`, `${this.baseUrl}?bookmark_id=${bookmarkId}`).then((response) => processResponse(response));
  }

  createCustomAlert(bookmarkId, alertParams = {}) {
    return fetch(`POST`, this.baseUrl, {
      bookmark_id: bookmarkId, // eslint-disable-line camelcase
      paused: false,
      ...alertParams,
    }).then((response) => processResponse(response));
  }

  updateCustomAlert(alertId, alertParams = {}) {
    const url = `${this.baseUrl}${alertId}`;
    return fetch(`PATCH`, url, alertParams).then((response) => processResponse(response));
  }
}

export const customAlertApi = (projectId) => new CustomAlertApi(projectId);
export const userApi = () => new UserApi();
export const projectApi = (projectId) => new ProjectApi(projectId);
